import React from "react";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  SubTitle,
  ThirdTitle,
} from "../ContentsStyles";

const CG_5 = () => {
  return (
    <>
      <Parah>
        We believe in an inclusive community and individual expression without
        fear of abuse. We do not tolerate members of our community being shamed,
        bullied, or harassed. Abusive content or behaviour can cause severe
        psychological distress and will be removed from our platform.
      </Parah>
      <SubTitle>Abusive Behaviour</SubTitle>
      <Parah>
        We remove expressions of abuse, including threats or degrading
        statements intended to mock, humiliate, embarrass, intimidate, or hurt
        an individual. This prohibition extends to the use of Talents Explore
        features. To enable expression about matters of public interest,
        critical comments of public figures may be allowed; however, serious
        abusive behaviour against public figures is prohibited.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that insults another individual or disparages an individual on
        the basis of attributes such as intellect, appearance, personality
        traits, or hygiene.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that encourages coordinated harassment.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that disparages victims of violent tragedies.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that uses TikTok interactive features (e.g., duet) to degrade
        others.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that depicts wilful harm or intimidation, such as cyberstalking
        or trolling.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that wishes death, serious disease, or other serious harm on an
        individual.
      </PointsWrapper>
      <SubTitle>Sexual Harassment</SubTitle>
      <Parah>
        Sexual harassment involves unwanted or inappropriate sexual behaviour
        directed at another individual. We do not allow content that glorifies,
        normalises or promotes sexual harassment, regardless of the user's
        intent.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that attempts to make unwanted sexual contact.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that disparages another person’s sexual activity.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that simulates sexual activity with another person, either
        verbally, in text (including emojis), or through the use of any in-app
        features.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that alters or morphs an image of another individual to portray
        or imply sexual suggestiveness or engagement in sexual activity.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that reveals, or threatens to reveal, details of a person's
        private sexual life, including digital content, sexual history, and
        names of previous sexual partners.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that exposes, or threatens to expose, a person's sexual
        orientation without their consent.
      </PointsWrapper>
      <SubTitle>Threats of Hacking, Doxing, and Blackmail</SubTitle>
      <Parah>
        Threatening to hack or dox with an intent to harass or blackmail another
        individual can cause serious emotional distress and other offline harm.
        We define doxing as the act of collecting and publishing personal data
        or personally identifiable information (PII) for malicious purposes. We
        consider these online behaviours as forms of abuse and do not allow them
        on our platform.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that threatens to reveal personal data or personally
        identifiable information (PII), including residential address, private
        email address, private phone number, bank statement, social security
        number, or passport number.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that threatens to blackmail an individual or to hack an
        individual's account.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that incites or encourages others to hack or reveal another
        person's account, personal data, or personally identifiable information
        (PII).
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        An individual's account, personal data, or personally identifiable
        information to encourage others to abuse, troll, or harass that
        individual.
      </PointsWrapper>
    </>
  );
};

export default CG_5;
